import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../customHooks/useAuth'

type PublicRouteProps = {
  children: React.JSX.Element
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { user } = useAuth()

  return user?.authenticated ? <Navigate to="/" replace /> : children
}

export default PublicRoute
